import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import firebase from "firebase/app";
import VuePageTransition from "vue-page-transition";
import VueTouch from 'vue-touch';
import InstantSearch from "vue-instantsearch";
import {
  Plugins
} from '@capacitor/core';
const {
  SplashScreen
} = Plugins;

Vue.use(VuePageTransition);
Vue.use(VueTouch);
Vue.use(InstantSearch);

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

let app = null;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
    SplashScreen.hide();
  }
});